import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { portalThemeResolver } from './core/resolvers/portal-theme.resolver';

/**
 * Consignor portal route table — plan §10.
 * Public routes (login + password flows) skip the shell via `hideShell: true`.
 * All authenticated routes share `authGuard` + AppLayoutComponent shell.
 */
export const routes: Routes = [
  {
    path: 'login',
    data: { hideShell: true },
    loadComponent: () => import('./features/login/pages/login.component').then(m => m.ConsignorLoginComponent)
  },
  {
    path: 'register',
    data: { hideShell: true },
    loadComponent: () =>
      import('./features/login/pages/register/register-page.component').then(m => m.RegisterPageComponent)
  },
  {
    path: 'forgot-password',
    data: { hideShell: true },
    loadComponent: () =>
      import('./features/login/pages/forgot-password/forgot-password-page.component').then(
        m => m.ForgotPasswordPageComponent
      )
  },
  {
    path: 'reset-password',
    data: { hideShell: true },
    loadComponent: () =>
      import('./features/login/pages/reset-password/reset-password-page.component').then(
        m => m.ResetPasswordPageComponent
      )
  },
  {
    path: 'activate',
    data: { hideShell: true },
    loadComponent: () =>
      import('./features/activation/pages/activate-page/activate-page.component').then(m => m.ActivatePageComponent)
  },
  {
    path: 'terms',
    data: { hideShell: true },
    loadComponent: () => import('./features/terms/pages/terms-page.component').then(m => m.TermsPageComponent)
  },
  {
    path: '',
    resolve: { _theme: portalThemeResolver },
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        data: { breadcrumb: 'Dashboard', feature: 'Dashboard' },
        loadComponent: () =>
          import('./shared/components/under-development/under-development.component').then(
            m => m.UnderDevelopmentComponent
          )
      },
      {
        path: 'carts',
        data: { breadcrumb: 'Drop-off Carts' },
        loadComponent: () =>
          import('./features/carts/pages/carts-page/carts-page.component').then(m => m.CartsPageComponent)
      },
      {
        path: 'carts/new',
        data: { breadcrumb: 'New drop-off cart' },
        loadComponent: () =>
          import('./features/carts/pages/cart-create-page/cart-create-page.component').then(
            m => m.CartCreatePageComponent
          )
      },
      {
        path: 'carts/:id/edit',
        data: { breadcrumb: 'Edit draft cart' },
        loadComponent: () =>
          import('./features/carts/pages/cart-create-page/cart-create-page.component').then(
            m => m.CartCreatePageComponent
          )
      },
      {
        path: 'carts/:id',
        data: { breadcrumb: 'Cart detail' },
        loadComponent: () =>
          import('./features/carts/pages/cart-detail-page/cart-detail-page.component').then(
            m => m.CartDetailPageComponent
          )
      },
      {
        path: 'items',
        data: { breadcrumb: 'Items' },
        loadComponent: () =>
          import('./features/items/pages/items-page/items-page.component').then(m => m.ItemsPageComponent)
      },
      {
        path: 'items/:id',
        data: { breadcrumb: 'Item detail' },
        loadComponent: () =>
          import('./features/items/pages/item-detail-page/item-detail-page.component').then(
            m => m.ItemDetailPageComponent
          )
      },
      {
        path: 'payouts',
        data: { breadcrumb: 'Payouts', feature: 'Payouts' },
        loadComponent: () =>
          import('./features/payouts/pages/payouts-page/payouts-page.component').then(m => m.PayoutsPageComponent)
      },
      {
        path: 'payouts/:id',
        data: { breadcrumb: 'Payout detail' },
        loadComponent: () =>
          import('./features/payouts/pages/payout-batch-detail-page/payout-batch-detail-page.component').then(
            m => m.PayoutBatchDetailPageComponent
          )
      },
      {
        path: 'disputes',
        data: { breadcrumb: 'Disputes' },
        loadComponent: () =>
          import('./features/disputes/pages/disputes-page/disputes-page.component').then(m => m.DisputesPageComponent)
      },
      {
        path: 'price-updates',
        data: { breadcrumb: 'Aging Price Requests' },
        loadComponent: () =>
          import('./features/price-updates/pages/price-updates-page/price-updates-page.component').then(
            m => m.PriceUpdatesPageComponent
          )
      },
      {
        path: 'disputes/:id',
        data: { breadcrumb: 'Dispute Detail' },
        loadComponent: () =>
          import('./features/disputes/pages/dispute-detail-page/dispute-detail-page.component').then(
            m => m.DisputeDetailPageComponent
          )
      },
      {
        path: 'profile',
        data: { breadcrumb: 'Profile' },
        loadComponent: () =>
          import('./features/profile/pages/profile-page/profile-page.component').then(m => m.ProfilePageComponent)
      }
    ]
  },
  {
    path: '**',
    data: { hideShell: true },
    loadComponent: () =>
      import('./shared/components/not-found/not-found-page.component').then(m => m.NotFoundPageComponent)
  }
];
